exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v--modal-overlay[data-v-27642120]{z-index:1000}.modal-header .fa-times[data-v-27642120]{cursor:pointer}", ""]);

// exports
